import type { MarketplaceFulfillmentStatus } from "@nexus/contracts";

import type { OrderScriptRow } from "../types/marketplace.types";
import { filledOrderLineVideos } from "./order-line-videos";

const LINE_STATUSES_VIDEO_REVISION_ROLLS_UP = new Set<MarketplaceFulfillmentStatus>([
  "SUBMITTED_FOR_FEEDBACK",
  "SUBMITTED_FOR_FINAL_APPROVAL",
  "SENT_FOR_REVISION",
]);

export function scriptHasVideoAwaitingRevision(script: OrderScriptRow): boolean {
  return filledOrderLineVideos(script).some(
    (video) => video.reviewStatus === "REVISION_REQUESTED",
  );
}

/** Line status partners and ops should treat as authoritative when videos disagree. */
export function effectiveScriptFulfillmentStatus(
  script: OrderScriptRow,
): MarketplaceFulfillmentStatus {
  if (!scriptHasVideoAwaitingRevision(script)) {
    return script.fulfillmentStatus;
  }
  if (LINE_STATUSES_VIDEO_REVISION_ROLLS_UP.has(script.fulfillmentStatus)) {
    return "SENT_FOR_REVISION";
  }
  return script.fulfillmentStatus;
}
